"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
class Utils {
    // this method and all its regexps are copied from TSW's utilityService.ts
    // https://domoreexp.visualstudio.com/DefaultCollection/Teamspace/_git/Teamspace-Web?path=%2Fmodules%2Fsrc%2Fmsteams-web-ng1-services%2Fsrc%2Fservices%2Futility%2FutilityService.ts&_a=contents&version=GBdevelop
    static scrubEuii(logString) {
        if (lodash_1.isNil(logString)) {
            return logString;
        }
        let retString = logString;
        lodash_1.keys(this.piiTypeRegexMap).forEach((key) => {
            retString = retString.replace(Utils.piiTypeRegexMap[key], key + '-pii');
        });
        return retString;
    }
    static isTabVisible() {
        return document.visibilityState === "visible";
    }
    // TODO: Accessing cookies from document is prohibited and must be reworked to follow security rules
    static returnDocumentCookie() {
        return document.cookie;
    }
    // TODO: Creating cookies from document is prohibited and must be reworked to follow security rules
    static setDocumentCookie(cookie) {
        document.cookie = cookie;
    }
}
exports.Utils = Utils;
Utils.fileRegex = new RegExp('(\\b.{5,11}[.]((doc[x]?)|(xls[x]?)|(ppt[x]?)|(pdf))\\b)', 'g');
Utils.emailRegex = new RegExp('(\\b[^.P]\\w{5,10}[^30\\s](@|%40)[^aefpstuU<*6]\\w{1,10}[.].{2,3})', 'g');
Utils.phoneRegex = new RegExp('((tel:\\s?[(\\d])|([+]?\\d{1,3}\\s?[(]\\d{3}[)][\\s]\\d{3}[-]\\d{4})|([(]\\d{3}[)][\\s]?\\d{3}[-]\\d{4})|(\\d{3}[-]\\d{3}[-]\\d{4}\\b)|(4:\\+\\d{8,12}))', 'g');
Utils.ipAddressRegex = new RegExp('(\\s[1-2]?[\\d]?[\\d][.][1-2]?[\\d]?[\\d][.][1-2]?[\\d]?[\\d][.][1-2]?[\\d]?[\\d][:][^148])', 'g');
Utils.ssnRegex = new RegExp('(\\d{3}[-]\\d{2}[-]\\d{4})', 'g');
Utils.creditCardRegex = new RegExp('(\\d{4}\\s\\d{4}\\s\\d{4}\\s\\d{4})', 'g');
Utils.piiTypeRegexMap = {
    ['file']: Utils.fileRegex,
    ['email']: Utils.emailRegex,
    ['phone']: Utils.phoneRegex,
    ['ipAddress']: Utils.ipAddressRegex,
    ['ssn']: Utils.ssnRegex,
    ['creditCard']: Utils.creditCardRegex
};
Utils.generateGuid = () => {
    const r = new Array(8);
    for (let i = 0; i < r.length; i += 2) {
        const val = Math.floor(Math.random() * 0x100000000);
        // tslint:disable-next-line: no-bitwise
        r[i] = Utils.formatAsHex(val & 0xffff);
        // tslint:disable-next-line: no-bitwise
        r[i + 1] = Utils.formatAsHex(val >>> 16);
        if (i + 1 === 3) {
            // RFC4122 requires a 4 in this position
            r[i + 1] = "4" + r[i + 1].substring(1);
        }
        if (i === 4) {
            // RFC4122 requires [089ab] hex values in the first position
            // tslint:disable-next-line:no-bitwise
            r[i] = (val & 0x3 | 0x8).toString(16) + r[i].substring(1);
        }
    }
    return (r[0] +
        r[1] +
        "-" +
        r[2] +
        "-" +
        r[3] +
        "-" +
        r[4] +
        "-" +
        r[5] +
        r[6] +
        r[7]);
};
Utils.generateHash = (input) => {
    let hash = 0;
    if (input.length === 0) {
        return hash;
    }
    for (let i = 0; i < input.length; i += 1) {
        const char = input.charCodeAt(i);
        // tslint:disable-next-line: no-bitwise
        hash = (hash << 5) - hash + char;
        // tslint:disable-next-line: no-bitwise
        hash = hash & hash;
    }
    return hash;
};
Utils.stripQSPFromUrl = (input) => {
    if (input && input.includes("launcher.html")) {
        return input.split("?")[0];
    }
    else {
        return input;
    }
};
Utils.formatAsHex = (n) => {
    let hex = n.toString(16);
    const padding = 4 - hex.length;
    for (let i = 0; i < padding; i += 1) {
        hex = "0" + hex;
    }
    return hex;
};
